<template>
  <div class="c-list">
    <CallCenterFilter v-if="haveFilters"></CallCenterFilter>
    <CallCenterTable></CallCenterTable>
  </div>
</template>

<script>
import CallCenterFilter from "@/components/filter.vue";
import CallCenterTable from "@/components/table.vue";
import { mapState } from "vuex";
export default {
  name: "c-list",
  components: {
    CallCenterFilter,
    CallCenterTable
  },
  computed: {
    ...mapState("aeds", ["filters"]),
    haveFilters() {
      return Object.keys(this.filters).length > 0;
    }
  }
};
</script>
<style lang="scss">
.c-list {
  background-color: $s-cp-neutral-900;
  padding: toRem(0 30px 60px);
}
</style>
